<template>
  <div id="rea-phone">
    <div class="phone-container" data-aos="fade-up" data-aos-duration="900">
      <div class="col-reas px-0">
        <img src="../images/Indicateurs.svg" v-set-alt>
        <p class="raleway-reg-p13">{{ $t("Reassurance.two") }}</p>
      </div>
      <div class="col-reas px-0">
        <img src="../images/PGM.svg" v-set-alt>
        <p class="raleway-reg-p13">{{ $t("Reassurance.three") }}</p>
      </div>
      <div class="col-reas px-0">
        <img src="../images/experiences.svg" v-set-alt>
        <p class="raleway-reg-p13">{{ $t("Reassurance.four") }}</p>
      </div>
      <div class="col-reas px-0 pl-2">
        <img src="../images/securite.svg" v-set-alt>
        <p class="raleway-reg-p13">{{ $t("Reassurance.six") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'rea-phone',
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/reassurance'>

#rea-phone {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
  padding-left: 20px;
  padding-right: 20px;

  .phone-container {
    display: grid;
    grid-template-columns: repeat(2, minmax(50%, 1fr));
  }

  .col-reas {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: stretch;
    text-align: center;
  }
}

</style>
